import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const items = [
  {
    key: "business-details",
    label: "Business Details",
    icon: (
      // Office building icon (3 windows, 2 floors, door, flat base, rounded corners)
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <rect x="5" y="4" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="8" y="7" width="2" height="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="14" y="7" width="2" height="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="11" y="7" width="2" height="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="11" y="15" width="2" height="5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="5" y1="20" x2="19" y2="20" stroke="currentColor" strokeWidth="1.5"/>
      </svg>
    ),
    to: "/account/business-details",
  },
  {
    key: "credentials",
    label: "Credentials",
    icon: (
      // Key/Lock icon for credentials
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
      </svg>
    ),
    to: "/account/credentials",
  },
  {
    key: "billing",
    label: "Billing",
    icon: (
      // Cash/Money icon
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="12" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M3 9.5c1.5 0 2.5-1 2.5-2.5M21 9.5c-1.5 0-2.5-1-2.5-2.5M3 14.5c1.5 0 2.5 1 2.5 2.5M21 14.5c-1.5 0-2.5 1-2.5 2.5" stroke="currentColor" strokeWidth="1.2"/>
      </svg>
    ),
    to: "/account/billing",
  },
  {
    key: "saved-library",
    label: "Saved Library",
    icon: (
      // Bookmark icon
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M6 4.75A2.75 2.75 0 0 1 8.75 2h6.5A2.75 2.75 0 0 1 18 4.75v14.13a.75.75 0 0 1-1.13.66l-4.37-2.49a.75.75 0 0 0-.74 0l-4.37 2.49A.75.75 0 0 1 6 18.88V4.75Z" stroke="currentColor" strokeWidth="1.5"/>
      </svg>
    ),
    to: "/account/saved-library",
  },
  {
    key: "mail-settings",
    label: "Mail Settings",
    icon: (
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    to: "/account/mail-settings",
  },
  {
    key: "interview-config",
    label: "AI Interview Settings",
    icon: (
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a7 7 0 00-7 7v4a3 3 0 003 3h1v-6H6v-1a6 6 0 0112 0v1h-3v6h1a3 3 0 003-3v-4a7 7 0 00-7-7z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 18c-.7 1.2-1.7 2-3 2h-1" />
      </svg>
    ),
    to: "/account/interview-config",
  },
  {
    key: "settings",
    label: "Settings",
    icon: (
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" strokeWidth="1.5"/></svg>
    ),
    to: "/account/settings",
  },
  {
    key: "score-config",
    label: "Score Configuration",
    icon: (
      <svg className="w-5 h-5 mr-2 inline-block" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <line x1="4" y1="6" x2="20" y2="6" strokeLinecap="round" />
        <circle cx="9" cy="6" r="2" fill="white" stroke="currentColor" strokeWidth="1.5" />
        <line x1="4" y1="12" x2="20" y2="12" strokeLinecap="round" />
        <circle cx="15" cy="12" r="2" fill="white" stroke="currentColor" strokeWidth="1.5" />
        <line x1="4" y1="18" x2="20" y2="18" strokeLinecap="round" />
        <circle cx="10" cy="18" r="2" fill="white" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
    to: "/account/score-config",
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = typeof location.state?.returnTo === "string" && location.state.returnTo.startsWith("/")
    ? location.state.returnTo
    : null;
  const fromScheduleInterview = location.state?.fromScheduleInterview === true;
  const returnState = returnTo ? { returnTo } : undefined;

  return (
    <aside className="w-64 bg-[#F6F7F9] dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex flex-col px-6 transition-colors duration-250 h-full">
      <div className="mt-6 mb-4 flex items-center gap-2">
        <button
          onClick={() => {
            if (fromScheduleInterview) {
              navigate(-1);
              return;
            }
            navigate(returnTo || '/dashboard');
          }}
          className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors text-gray-500 dark:text-gray-400"
          title="Go back"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2 className="text-sm font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">Account</h2>
      </div>
      <nav className="flex flex-col gap-4">
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            state={returnState}
            className={({ isActive }) =>
              `flex items-center px-4 py-2 rounded-xl font-medium text-base transition-colors duration-200 gap-2 ` +
              (isActive
                ? "bg-[#B8C4FA] text-[#222B45] font-semibold shadow-sm dark:bg-gray-700 dark:text-white"
                : "text-gray-600 hover:bg-gray-100 dark:text-gray-100 dark:hover:bg-gray-700")
            }
            end
          >
            {item.icon}
            <span className="transition-colors duration-200">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
